module.exports = __webpack_public_path__ + "img/logo_mediurs.4be50c07.png";